<template>
  <div class="manage-goods-container">
    <div>
      <h2>商品管理</h2>
    </div>
    <!-- 状态切换tabs -->
    <StatusChangeBar @statusChange="statusChange" />
    <!-- 搜索条 -->
    <SearchBar :selfOperatedShop="selfOperatedShop" @searchClick="searchClick" @resetClick="resetClick" />
    <!-- 表格 -->
    <div class="table-box">
      <el-table
        v-loading="isLoading"
        :data="spuList"
        style="width: 100%; margin-bottom: 20px"
        row-key="goodsId"
        border
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        >
        <el-table-column type="index" width="50">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <el-checkbox v-model="scope.row.checked" @change="oneSpuCheckedChange"></el-checkbox>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品名称" min-width="20%" />
        <el-table-column align="center" label="商品图片" min-width="15%">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px" :src="`${scope.row.picUrl}?imageView2/1/w/50/h/50`" fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="规格" :align="'ceter'" min-width="10%">
          <template slot-scope="scope">
            <template v-if="scope.row.specType === 0">{{ scope.row.children && scope.row.children[0].skuSpecsIndex }}</template>
            <template v-else>
              <div v-if="!scope.row.isSpu">
                {{ scope.row.skuSpecsIndex }}
              </div>
              <div v-else class="nodata_line_color">——</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="价格(元)" min-width="10%">
          <template slot-scope="scope">
            <div class="flex items-center" v-if="!scope.row.specType">
              <template v-if="scope.row && scope.row.laddersPriceStr">
                {{ scope.row.laddersPriceStr }}
              </template>
              <template v-else>
                {{ scope.row && scope.row.marketPriceStr }}
              </template>
              <template v-if="!scope.row.isoa && !scope.row.usefulLaddersPrice">
                <el-popover v-model="scope.row.marketPriceStrVisible" placement="right" width="250" trigger="click">
                  <div>
                    <el-input
                      maxlength="20"
                      v-model="scope.row.marketPriceStrTem"
                      placeholder="请输入价格"
                      oninput="value=value.replace(/^([0-9-]\d*\.?\d{0,6})?.*$/,'$1')"
                    ></el-input>
                  </div>
                  <div class="text-right mar10-t">
                    <el-button size="mini" @click="scope.row.marketPriceStrVisible = false">取消</el-button>
                    <el-button size="mini" type="primary" @click="marketPriceStrChange(scope.row)">确定</el-button>
                  </div>
                  <i slot="reference" class="el-icon-edit pointer mar5-l"></i>
                </el-popover>
              </template>
            </div>
            <template v-else><div class="nodata_line_color">——</div></template>

            <!-- <template v-if="scope.row.specType === 0">{{ scope.row.children && scope.row.children[0].marketPriceStr }}</template>
            <template v-else>
              <div v-if="!scope.row.isSpu">
                {{ scope.row.marketPriceStr }}
              </div>
              <div v-else class="nodata_line_color">——</div>
            </template> -->
          </template>
        </el-table-column>
        <el-table-column label="单位" min-width="10%">
          <template slot-scope="scope">
            <template v-if="scope.row.specType === 0">{{ scope.row.children && scope.row.children[0].unitName }}</template>
            <template v-else>
              <div v-if="!scope.row.isSpu">
                {{ scope.row.unitName }}
              </div>
              <div v-else class="nodata_line_color">——</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="currQuantity" label="库存" min-width="10%">
          <template slot-scope="scope">
            <div class="flex items-center" v-if="!scope.row.specType">
              {{ (scope.row && scope.row.currQuantity) || "0" }}
              <el-popover v-model="scope.row.visible" placement="right" width="250" trigger="click">
                <div>
                  <el-input
                    maxlength="10"
                    v-model="scope.row.currQuantityTem"
                    placeholder="请输入库存"
                    oninput="value = value.replace(/[^0-9]/g, '')"
                  ></el-input>
                </div>
                <div class="text-right mar10-t">
                  <el-button size="mini" @click="scope.row.visible = false">取消</el-button>
                  <el-button size="mini" type="primary" @click="currQuantityChange(scope.row)">确定</el-button>
                </div>
                <i slot="reference" class="el-icon-edit pointer mar5-l"></i>
              </el-popover>
            </div>
            <template v-else><div class="nodata_line_color">——</div></template>
          </template>
        </el-table-column>
        <el-table-column label="分类" min-width="10%">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <div class="flex items-center" v-if="scope.row.goodsType" @click="showCategroyDialogClick(scope.row, true)">
                <div>{{ scope.row.goodsType }}</div>
                <i slot="reference" class="el-icon-edit pointer mar5-l"></i>
              </div>
              <el-button v-else type="text" @click="showCategroyDialogClick(scope.row)">+添加</el-button>
            </template>
            <template v-else><div class="nodata_line_color">——</div></template>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="10%">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <span v-if="scope.row.status == 1"> 已保存 </span>
              <span v-if="scope.row.status == 2" style="color: #1890ff"> 待审核 </span>
              <span v-if="scope.row.status == 9" style="color: #ff7f27"> 店铺驳回 </span>
              <span v-if="scope.row.status == 5" style="color: #188506"> 出售中 </span>
              <span v-if="scope.row.status == 6" style="color: red"> 已下架 </span>
              <el-tooltip class="flex items-center" effect="dark" :content="scope.row.rejectReason" placement="top">
                <div v-if="scope.row.status == 8" class="flex items-baseline" style="color: red">
                  <i class="el-icon-info"></i>
                  <div class="mar5-l">强制下架</div>
                </div>
              </el-tooltip>
              <el-tooltip class="flex items-center" effect="dark" :content="scope.row.rejectReason" placement="top">
                <div v-if="scope.row.status == 3" class="flex items-baseline" style="color: #ff7f27">
                  <i class="el-icon-info"></i>
                  <div class="mar5-l">驳回</div>
                </div>
              </el-tooltip>
            </template>
            <template v-else class="nodata_line_color"><div class="nodata_line_color">——</div></template>
          </template>
        </el-table-column>
        <el-table-column label="企联网商品" min-width="10%">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <span>{{ scope.row.isoa ? "是" : "否" }}</span>
            </template>
            <template v-else class="nodata_line_color"><div class="nodata_line_color">——</div></template>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="420">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <el-button v-if="scope.row.status != 2 && scope.row.status != 3" size="mini" @click="editSpuClick(scope.row)">编辑</el-button>
              <el-button v-if="scope.row.status == 5" size="mini" @click="oneXiaJia(scope.row)">下架</el-button>
              <el-button v-if="scope.row.status == 1 || scope.row.status == 6" size="mini" @click="oneShangJia(scope.row)">上架</el-button>
              <el-button v-if="scope.row.status == 2" size="mini" @click="cancelAudit(scope.row)">取消审核</el-button>
              <el-button v-if="scope.row.status == 3" size="mini" @click="editSpuClick(scope.row)">重新编辑</el-button>
              <el-button
                v-if="scope.row.status == 1 || scope.row.status == 3 || scope.row.status == 6 || scope.row.status == 8"
                size="mini"
                @click="goodsDeleteClick(scope.row)"
                >删除</el-button
              >
              <el-button v-if="scope.row.status != 3" size="mini" @click="lookQRCodeClick(scope.row)">二维码</el-button>
              <el-button v-if="scope.row.togetherLaddersPrice == 1" type="primary" size="mini" @click="commonLaddersPriceConfig(scope.row, 0)"
                >关闭共用阶梯</el-button
              >
              <el-button
                v-if="
                  !scope.row.togetherLaddersPrice && scope.row.specialList && scope.row.specialList.length === 1 && enableLaddersPrice != '0' && !scope.row.isoa
                "
                size="mini"
                type="primary"
                @click="commonLaddersPriceConfig(scope.row, 1)"
                >启用共用阶梯</el-button
              >
            </template>
            <template v-else>
              <el-button v-if="scope.row.status != 3" size="mini" @click="lookQRCodeClick(scope.row)">二维码</el-button>
            </template>
            <template v-if="!scope.row.specType && enableLaddersPrice != '0' && !scope.row.isoa">
              <el-button size="mini" type="primary" @click="laddersPriceConfig(scope.$index, scope.row)">阶梯价</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="bottom-handle-box">
      <el-checkbox v-model="selectAll">全选</el-checkbox>
      <el-divider direction="vertical"></el-divider>
      <el-button type="text" style="color: #606266" @click="batchShangJia">批量上架</el-button>
      <el-button type="text" style="color: #606266" @click="batchXiaJia">批量下架</el-button>
      <el-button type="text" style="color: #606266" @click="batchaddCate">批量分类</el-button>
      <el-button type="text" style="color: #606266" @click="batchDeleteClassify">移除分类</el-button>
      <el-button type="text" style="color: #606266" @click="batchEditGoods">批量编辑</el-button>
    </div>
    <div class="pagination-box">
      <el-pagination background layout="prev, pager, next" :total="total" :current-page="currentPage" @current-change="handleCurrentChange"> </el-pagination>
    </div>
    <CategoryDialog
      ref="categoryDialogref"
      :isEdit="categoryIsEdit"
      v-if="showCategoryDialog"
      :showCategoryDialog.sync="showCategoryDialog"
      @reloadspuList="reloadspuList"
    />
    <el-dialog :title="selfOperatedShop ? '爆品活动' : '二维码'" :visible.sync="showQRCodeDialog" width="300px">
      <el-row type="flex" justify="center">
        <div v-if="selfOperatedShop" class="relative text-center operated-shop">
          <div>保存二维码或链接直接分享好友参加活动</div>
          <img class="mar10-tb" :src="qrDate.qrcodeImgUrl" />
          <div class="pad10-tb">
            <el-button size="mini" type="primary" @click="qrcodeImgUrlDown">下载二维码</el-button>
          </div>
          <div class="flex justify-center mar20-t">
            <div>{{ qrDate.shareUrl }}</div>
            <div class="blue pad10-lr pointer" @click="copyLink">复制</div>
          </div>
        </div>
        <template v-else>
          <div class="qrCode-box">
            <canvas ref="qrCodeCanvas" />
            <div class="img-box">
              <el-image style="width: 30px; height: 30px" :src="showQRDialogImgUrl" fit="cover"></el-image>
            </div>
          </div>
        </template>
      </el-row>
    </el-dialog>

    <el-dialog title="阶梯价设置" :visible.sync="goodPriceVisible" :close-on-click-modal="false" width="600px">
      <template>
        <el-form>
          <el-form-item label="阶梯价：" prop="mobile" class="mar10-r">
            <el-radio-group v-model="goodsEnableLaddersPrice" @change="laddersPriceEnableChange">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">不启用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <template v-if="showLaddersPriceSetting">
          <div class="pad20_b">
            <el-button type="primary" class="mar10-r" @click="addGoodPrice">添加</el-button>
            <i class="el-icon-question"></i>
            <span class="mar5-l">最多设置三级阶梯，阶梯量逐级递增，阶梯价逐级递减且不可高于市场价</span>
          </div>
          <el-table class="goodPriceTable" :data="goodsPriceList" style="width: 100%">
            <el-table-column prop="level" label="阶梯" width="100" />
            <el-table-column prop="minQuantity" :label="'阶梯量(' + laddersSkuUnit + ')'">
              <template slot-scope="scope">
                <span class="mar5-r">≥</span>
                <el-input v-model="scope.row.minQuantity" oninput="value=value.replace(/\D|^0/g,'')"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="阶梯价(￥)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.price" @blur="scope.row.price = formatNums(scope.row.price, true)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <i
                  v-if="goodsPriceList.length > 2 && scope.row.level !== 1 && scope.row.level !== 2"
                  class="el-icon-delete cursor"
                  @click="delGoodPrice(scope.$index)"
                ></i>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="goodPriceVisible = false">取 消</el-button>
        <el-button type="primary" @click="goodsPriceConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import requestSC from "@/utils/requestSC";
import { getGoodsShopCategory } from "@/api/publishGoods/publishGoods";
import { getGoodsSpuList, goodsModifyStatus, goodsShopClassifyDelete, goodsDelete } from "@/api/manageGoods/manageGoods";
import QrCode from "qrcode";
import { Loading } from "element-ui";
import requestApi from "@/utils/requestApi";
import StatusChangeBar from "./components/StatusChangeBar.vue";
import SearchBar from "./components/SearchBar.vue";
import CategoryDialog from "./components/CategoryDialog.vue";

export default {
  components: {
    StatusChangeBar,
    SearchBar,
    CategoryDialog,
  },
  data() {
    return {
      status: "", //当前要查看哪种状态
      name: "", // 搜索框输入的商品名称
      customCateId: "", // 搜索框,分类id
      currentPage: 1, //当前页码
      total: 0, // 总共多少条数据
      isLoading: false, // 是否正在加载
      spuList: [],
      showCategoryDialog: false,
      showQRCodeDialog: false, // 是否展示二维码
      showQRDialogImgUrl: "", // 二维码url
      categoryIsEdit: false,
      selfOperatedShop: true, // 是否直营
      enableLaddersPrice: "0", // 是否启用商品阶梯价
      qrDate: {},
      goodPriceVisible: false,
      goodsPriceList: [], // 阶梯设置的list
      goodsEnableLaddersPrice: 0, // 某商品是否启用阶梯价
      laddersPriceActivityId: "", // 阶梯价活动ID
      laddersPriceSkuId: "", // 设置阶梯价商品ID
      laddersSkuMarketPrice: "", // 设置阶梯价的商品 市场价
      laddersSkuPriceDigit: "2", // 当前sku 价格保留位数
      laddersSkuUnit: "", // 当前sku 计量单位
      showLaddersPriceSetting: false, // 是否展示设置阶梯框
    };
  },
  created() {
    requestSC.get("rest/mj/goods/seq/shopConfig").then((res) => {
      this.selfOperatedShop = res.data.selfOperatedShop;
      this.enableLaddersPrice = res.data.funcSettingMap.is_enable_ladders_price;
    });
    this.loadGetGoodsSpuList();
    this.loadGetGoodsShopCategory();
  },
  computed: {
    // 全选按钮是否选中
    selectAll: {
      get() {
        return this.spuList.length && this.spuList.every((item) => item.checked);
      },
      // 设置全选或者全不选
      set(value) {
        this.spuList.forEach((item) => (item.checked = value));
        this.spuList = [...this.spuList];
      },
    },
  },
  methods: {
    // 复制
    copyLink() {
      const textarea = document.createElement("textarea");
      textarea.value = this.qrDate.shareUrl;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);

      this.$message({
        type: "success",
        message: "复制成功",
      });
    },
    // 下载二维码
    qrcodeImgUrlDown() {
      const { qrcodeImgUrl } = this.qrDate;
      if (!qrcodeImgUrl) {
        this.$message.warning("未获取到二维码");
        return;
      }
      event.preventDefault();
      var xhr = new XMLHttpRequest();
      xhr.open("GET", qrcodeImgUrl, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = new Blob([this.response], { type: "image/jpeg" });
          var url = URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = "爆品活动.jpg";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
      };
      xhr.send();
    },
    async loadGetGoodsShopCategory() {
      const result = await getGoodsShopCategory();
      this.customCateList = result.data;
    },
    async loadGetGoodsSpuList() {
      this.spuList = [];
      const params = {
        size: 10, // 页码大小
        current: this.currentPage,
      };

      if (this.status) {
        params.status = this.status;
      }

      if (this.name) {
        params.name = this.name;
      }

      if (this.customCateId) {
        params.shopDecorateId = this.customCateId;
      }
      try {
        this.isLoading = true;
        const result = await getGoodsSpuList(params);
        this.total = result.data.total;
        // 开始洗数据
        // const spuList = [];

        this.spuList = result.data.records.map((spuItem, index) => {
          const totalQuantity = spuItem.skuList.reduce((sum, item) => sum + item.currQuantity, 0);
          return {
            ...spuItem,
            children: spuItem.skuList.map((children, childrenIndex) => ({
              ...children,
              skuId: children.goodsId,
              spuIndex: index,
              skuIndex: childrenIndex,
              isSpu: false,
              isMultiSpec: spuItem.specType === 1, // 是否多规格
              togetherLaddersPrice: spuItem.togetherLaddersPrice, // 是否共同阶梯
            })),
            skuId: spuItem.skuList[0].goodsId,
            isSpu: true, // 这一级是spu
            isMultiSpec: spuItem.specType === 1, // 是否多规格
            checked: false,
            goodsId: `${spuItem.id}${spuItem.createTime}`, // spu级别的goodsId 仅作为 vueKey 使用,为避免老数据spuid和skuid重复问题,故加上了创建时间
            currQuantity: totalQuantity,
            marketPriceStr: spuItem.skuList[0].marketPriceStr,
            laddersPriceStr: spuItem.skuList[0].laddersPriceStr,
            usefulLaddersPrice: spuItem.skuList[0].usefulLaddersPrice,
            isoa: spuItem.skuList[0].isoa,
            spuIndex: index,
            hasChildren: spuItem.specType === 0,
          };
        });

        // for (let index = 0; index < result.data.records.length; index++) {
        //   const spuItem = result.data.records[index];

        //   // 算一下每个spu的总库存
        //   const totalQuantity = spuItem.skuList.reduce((sum, item) => sum + item.currQuantity, 0);

        //   const spuObj = {
        //     ...spuItem,
        //     isSpu: true, // 这一级是spu
        //     checked: false,
        //     goodsId: `${spuItem.id}${spuItem.createTime}`, //
        //     currQuantity: totalQuantity,
        //     isoa: 0
        //   };

        //   if (spuItem.skuList.length && spuItem.specType !== 0) {
        //     spuObj.isoa = spuItem.skuList[0].isoa;
        //     spuObj.children = spuItem.skuList;
        //   }

        //   spuList.push(spuObj);
        // }
        // this.spuList = spuList;
        this.isLoading = false;
        console.log("数组", this.spuList);
      } catch (error) {
        this.isLoading = false;
      }
    },
    //状态status改变赋值,重新请求数据
    statusChange({ name }) {
      this.currentPage = 1;
      this.status = name;
      this.loadGetGoodsSpuList();
    },
    //搜索点击获取值
    searchClick({ name, customCateId }) {
      this.currentPage = 1;
      this.name = name;
      this.customCateId = customCateId;
      this.loadGetGoodsSpuList();
    },
    //重置点击了
    resetClick() {
      this.currentPage = 1;
      this.name = "";
      this.customCateId = "";

      this.loadGetGoodsSpuList();
    },
    //改变当前页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadGetGoodsSpuList();
    },
    oneSpuCheckedChange() {
      this.spuList = [...this.spuList];
    },
    // 批量事件,获取spuids
    getCheckedSpuIds() {
      const spuIds = [];
      this.spuList.forEach((item) => {
        if (item.checked) {
          spuIds.push(item.id);
        }
      });

      if (spuIds.length) {
        return spuIds;
      } else {
        this.$message.error("请选择商品!");
        return;
      }
    },
    // 展示分类dialog
    async showCategroyDialogClick(obj, isEdit = false) {
      this.showCategoryDialog = true;
      this.categoryIsEdit = isEdit;
      await this.$nextTick();
      this.$refs.categoryDialogref.spuIds = [obj.id];
    },
    //编辑,重新编辑spu
    editSpuClick(obj) {
      this.$router.push(`publishgoods?spuId=${obj.id}&appid=1&isShowTitle=1`);
    },
    // 单一上架
    async oneShangJia(obj) {
      try {
        const result = await goodsModifyStatus({ status: 5, spuIds: [obj.id] });

        if (result.code == 0 || result.code == 3) {
          this.$message.success(result.msg || "上架成功");
          this.loadGetGoodsSpuList();
        } else {
          this.$message.error(result.msg || "上架失败");
        }
      } catch (error) {
        this.$message.error("上架失败");
      }
    },
    // 单一下架
    async oneXiaJia(obj) {
      try {
        const result = await goodsModifyStatus({ status: 6, spuIds: [obj.id] });

        if (result.code != 0) {
          this.$message.error(result.msg || "下架失败");
        } else {
          this.$message.success("下架成功");
          this.loadGetGoodsSpuList();
        }
      } catch (error) {
        this.$message.error("下架失败");
      }
    },
    // 取消审核
    async cancelAudit(obj) {
      try {
        const result = await goodsModifyStatus({ status: 1, spuIds: [obj.id] });

        if (result.code != 0) {
          this.$message.error(result.msg || "取消审核失败");
        } else {
          this.$message.success("取消审核成功");

          this.loadGetGoodsSpuList();
        }
      } catch (error) {
        this.$message.error("取消审核失败");
      }
    },
    // 删除
    async goodsDeleteClick(obj) {
      try {
        const result = await goodsDelete({ spuIds: [obj.id] });

        if (result.code != 0) {
          this.$message.error(result.msg || "删除失败");
        } else {
          this.$message.success("删除成功");

          this.loadGetGoodsSpuList();
        }
      } catch (error) {
        this.$message.error("删除失败");
      }
    },
    //查看二维码
    async lookQRCodeClick(obj) {
      console.log(obj);
      if (this.selfOperatedShop) {
        const loadingInstance = Loading.service({
          lock: true,
          text: "二维码生成中",
          fullscreen: true,
          customClass: "seller-style",
        });

        const { data } = await requestSC.get(`rest/wx/qrcode/GOODS_DTL/${obj.spuId}/200/0`);

        this.qrDate = data;

        loadingInstance.close();

        this.showQRCodeDialog = true;
      } else {
        this.showQRCodeDialog = true;
        await this.$nextTick();

        this.showQRDialogImgUrl = obj.picUrl;

        let goodsId = "";
        if (obj.isSpu && obj.skuList.length) {
          goodsId = obj.skuList[0].goodsId;
        } else {
          goodsId = obj.goodsId;
        }

        QrCode.toCanvas(this.$refs.qrCodeCanvas, `${process.env.VUE_APP_APP}goods/queryGoodsDetailInfo/${goodsId}`, {
          width: 200,
          height: 200,
        });
      }
    },
    // 批量上架
    async batchShangJia() {
      const spuIds = this.getCheckedSpuIds();
      if (!spuIds) {
        return;
      }

      try {
        const result = await goodsModifyStatus({ status: 5, spuIds });

        if (result.code == 0 || result.code == 3) {
          this.$message.success(result.msg || "上架成功");
          this.loadGetGoodsSpuList();
        } else {
          this.$message.error(result.msg || "上架失败");
        }
      } catch (error) {
        this.$message.error("上架失败");
      }
    },
    // 批量下架
    async batchXiaJia() {
      const spuIds = this.getCheckedSpuIds();
      if (!spuIds) {
        return;
      }

      try {
        const result = await goodsModifyStatus({ status: 6, spuIds });

        if (result.code != 0) {
          this.$message.error(result.msg || "下架失败");
        } else {
          this.$message.success("下架成功");

          this.loadGetGoodsSpuList();
        }
      } catch (error) {
        this.$message.error("下架失败");
      }
    },
    // 批量分类
    async batchaddCate() {
      const spuIds = this.getCheckedSpuIds();
      if (!spuIds) {
        return;
      }
      this.showCategoryDialog = true;
      await this.$nextTick();
      this.$refs.categoryDialogref.spuIds = spuIds;
    },
    // 移除分类
    async batchDeleteClassify() {
      const spuIds = this.getCheckedSpuIds();
      if (!spuIds) {
        return;
      }

      try {
        const result = await goodsShopClassifyDelete({ spuIds });

        if (result.code != 0) {
          this.$message.error(result.msg || "移除分类失败");
        } else {
          this.$message.success("移除分类成功");

          this.loadGetGoodsSpuList();
        }
      } catch (error) {
        this.$message.error("移除分类失败");
      }
    },
    // 批量编辑
    batchEditGoods() {
      const selectSpuList = [];
      this.spuList.forEach((item) => {
        if (item.checked) {
          selectSpuList.push(item);
        }
      });

      if (!selectSpuList.length) {
        this.$message.error("请选择商品!");
        return;
      }

      const ishaveoa = selectSpuList.some((item) => item.isoa == 1);

      if (ishaveoa) {
        this.$message.error("oa商品暂不可批量编辑!");
        return;
      }

      this.$router.push({
        name: "batchEditGoods",
        params: { selectSpuList },
      });
    },
    reloadspuList() {
      this.loadGetGoodsSpuList();
    },
    currQuantityChange(data) {
      const { isMultiSpec, skuId, spuIndex, skuIndex, currQuantityTem } = data;

      requestSC
        .post(
          "mj/updateGoodsCurrNum.do",
          qs.stringify({
            goodsId: skuId,
            currNum: currQuantityTem,
            origNum: currQuantityTem,
          })
        )
        .then((res) => {
          const { msg, code } = res;
          if (code == "0") {
            if (isMultiSpec) {
              this.$set(this.spuList[spuIndex].children[skuIndex], "currQuantity", currQuantityTem);
              this.$set(this.spuList[spuIndex].children[skuIndex], "visible", false);
            } else {
              this.$set(this.spuList[spuIndex], "currQuantity", currQuantityTem);
              this.$set(this.spuList[spuIndex], "visible", false);
            }
          } else {
            this.$message.error(msg);
          }
        });
    },
    marketPriceStrChange(data) {
      const { isMultiSpec, skuId, spuIndex, skuIndex, marketPriceStrTem } = data;

      requestSC
        .post(
          "mj/updateMarketPrice",
          qs.stringify({
            goodsId: skuId,
            marketPrice: marketPriceStrTem,
          })
        )
        .then((res) => {
          const { msg, code } = res;
          if (code == "0") {
            if (isMultiSpec) {
              this.$set(this.spuList[spuIndex].children[skuIndex], "marketPriceStr", marketPriceStrTem);
              this.$set(this.spuList[spuIndex].children[skuIndex], "marketPriceStrVisible", false);
            } else {
              this.$set(this.spuList[spuIndex], "marketPriceStr", marketPriceStrTem);
              this.$set(this.spuList[spuIndex], "marketPriceStrVisible", false);
            }
          } else {
            this.$message.error(msg);
          }
        });
    },
    // 阶梯价
    laddersPriceConfig(index, row) {
      this.laddersPriceActivityId = "";
      let goodsId = "";
      let marketPrice = "";
      let unitName = "";
      if (row.isSpu && row.skuList.length) {
        goodsId = row.skuList[0].goodsId;
        marketPrice = row.skuList[0].marketPrice;
        unitName = row.skuList[0].unitName;
      } else {
        goodsId = row.goodsId;
        marketPrice = row.marketPrice;
        unitName = row.unitName;
        if (row.togetherLaddersPrice && row.togetherLaddersPrice == 1) {
          this.$message.warning("请先关闭共同阶梯再设置阶梯价");
          return;
        }
      }
      this.laddersPriceSkuId = goodsId;
      this.laddersSkuMarketPrice = marketPrice;
      this.laddersSkuUnit = unitName;
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/activity/commonactivitydtl/selList/JTJ`, {
          skuId: goodsId,
        })
        .then((res) => {
          if (res.code == "0") {
            if (res.data && res.data.length > 0 && res.data[0].laddersPrice) {
              this.laddersPriceActivityId = res.data[0].activityId;
              this.goodsPriceList = res.data[0].laddersPrice.goodsPriceList;
              this.goodsEnableLaddersPrice = res.data[0].laddersPrice.goodsEnableLaddersPrice;
              this.goodPriceVisible = true;
              this.laddersPriceEnableChange();
              return;
            }
            // 没有设置过阶梯价
            this.goodsPriceList = [];
            const item = {
              level: 1,
              minQuantity: "",
              maxQuantity: "",
              price: "",
            };
            this.goodsPriceList.push(item);
            const item1 = {
              ...item,
              level: 2,
            };
            this.goodsPriceList.push(item1);
            this.goodsEnableLaddersPrice = 1;
            this.goodPriceVisible = true;
            this.laddersPriceEnableChange();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.$message.error("查询失败");
        });

      requestSC.get(`rest/mj/goods/seq/shopConfig?categoryId=${row.categoryId}`).then((res) => {
        this.laddersSkuPriceDigit = res.data.goodsPriceDigit;
      });
    },
    addGoodPrice() {
      if (this.goodsPriceList.length >= 3) {
        this.$message.warning("最多设置三级阶梯");
        return;
      }
      const level = this.goodsPriceList.length + 1;
      const item = {
        level,
        minQuantity: "",
        maxQuantity: "",
        price: "",
      };
      this.goodsPriceList.push(item);
    },
    delGoodPrice(index) {
      this.goodsPriceList.splice(index, 1);
      this.goodsPriceList.forEach((item, index) => {
        item.level = index + 1;
      });
    },
    goodsPriceConfirm() {
      console.log("阶梯价格：", this.goodsPriceList);
      if (!this.goodsPriceList) {
        return;
      }

      // 未启用，不校验
      if (this.goodsEnableLaddersPrice == 0) {
        // 新增
        if (!this.laddersPriceActivityId) {
          this.saveLaddersPrice();
          return;
        }

        // 编辑阶梯价
        this.modifyLaddersPrice();
        return;
      }

      // 阶梯最大价格 不能超过商品市场价
      let maxPrice = this.goodsPriceList[0].price;
      if (maxPrice > this.laddersSkuMarketPrice) {
        this.$message.warning("阶梯价应小于等于市场价");
        return;
      }

      if (
        this.goodsPriceList.some((item) => {
          return !item.minQuantity;
        })
      ) {
        this.$message.warning("请设置阶梯量");
        return;
      }
      if (
        this.goodsPriceList.some((item) => {
          return !item.price;
        })
      ) {
        this.$message.warning("请设置价格");
        return;
      }

      const minQuantityList = [];
      const priceList = [];
      this.goodsPriceList.forEach((item, index) => {
        minQuantityList.push(Number(item.minQuantity));
        priceList.push(Number(item.price));
        if (index + 1 === this.goodsPriceList.length) {
          item.maxQuantity = -1;
        } else {
          item.maxQuantity = this.goodsPriceList[index + 1].minQuantity;
        }
      });
      const isSorted = (nums) => {
        return nums.every((x, i) => i === 0 || x > nums[i - 1]);
      };
      if (!isSorted(minQuantityList)) {
        this.$message.warning("阶梯量应逐级递增");
        return;
      }
      if (!isSorted(priceList.reverse())) {
        this.$message.warning("阶梯价应逐级递减");
        return;
      }
      // 新增
      if (!this.laddersPriceActivityId) {
        this.saveLaddersPrice();
        return;
      }

      // 编辑阶梯价
      this.modifyLaddersPrice();
    },

    // 新增阶梯价
    saveLaddersPrice() {
      // 请求主体
      let reqBatchList = [];

      // 活动商品
      let activityGoodsList = [];
      let skuObj = {};
      skuObj.skuId = this.laddersPriceSkuId;
      activityGoodsList.push(skuObj);

      // 活动明细
      let activityDtlList = [];
      let dtlObj = {};

      let basicValueObj = {};
      basicValueObj.goodsEnableLaddersPrice = this.goodsEnableLaddersPrice;
      let goodsPriceList = [];
      this.goodsPriceList.forEach((item) => {
        let goodsPrice = {};
        goodsPrice.level = item.level;
        goodsPrice.minQuantity = item.minQuantity;
        goodsPrice.maxQuantity = item.maxQuantity;
        goodsPrice.price = item.price;
        goodsPriceList.push(goodsPrice);
      });
      basicValueObj.goodsPriceList = goodsPriceList;
      dtlObj.basicFormatValue = JSON.stringify(basicValueObj);
      activityDtlList.push(dtlObj);

      let reqObj = {};
      reqObj.activityGoodsList = activityGoodsList;
      reqObj.activityDtlList = activityDtlList;
      reqObj.name = this.laddersPriceSkuId + "-阶梯价";
      reqBatchList.push(reqObj);
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/activity/commonactivity/mj/addBatch`, {
          type: "JTJ",
          reqBatchList: reqBatchList,
        })
        .then((res) => {
          if (res.code == "0") {
            this.$message.success("添加成功");
            this.goodPriceVisible = false;
            this.loadGetGoodsSpuList();
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 编辑阶梯价
    modifyLaddersPrice() {
      // 活动明细
      let activityDtlList = [];
      let dtlObj = {};

      let basicValueObj = {};
      basicValueObj.goodsEnableLaddersPrice = this.goodsEnableLaddersPrice;
      let goodsPriceList = [];
      this.goodsPriceList.forEach((item) => {
        let goodsPrice = {};
        goodsPrice.level = item.level;
        goodsPrice.minQuantity = item.minQuantity;
        goodsPrice.maxQuantity = item.maxQuantity;
        goodsPrice.price = item.price;
        goodsPriceList.push(goodsPrice);
      });
      basicValueObj.goodsPriceList = goodsPriceList;
      dtlObj.basicFormatValue = JSON.stringify(basicValueObj);
      activityDtlList.push(dtlObj);

      // 活动商品
      let activityGoodsList = [];
      let skuObj = {};
      skuObj.skuId = this.laddersPriceSkuId;
      activityGoodsList.push(skuObj);

      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/activity/commonactivity/mj/modify`, {
          id: this.laddersPriceActivityId,
          activityDtlList: activityDtlList,
          activityGoodsList: activityGoodsList,
        })
        .then((res) => {
          if (res.code == "0") {
            this.$message.success("操作成功");
            this.goodPriceVisible = false;
            this.loadGetGoodsSpuList();
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    formatNums(nums, decimal) {
      let value = `${nums}`;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      let digit = 6;
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0," + digit + "}).*$");
      value = value.replace(reg, "$1$2.$3");
      console.info(value);
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      if (value && !decimal) {
        value = parseInt(value, 10);
      }
      if (value === 0) {
        return "";
      }
      return value;
    },
    laddersPriceEnableChange() {
      if (this.goodsEnableLaddersPrice == 1) {
        this.showLaddersPriceSetting = true;
      }
      if (this.goodsEnableLaddersPrice == 0) {
        this.showLaddersPriceSetting = false;
      }
    },

    // 开启/关闭 共同阶梯
    commonLaddersPriceConfig(row, togetherLaddersPrice) {
      // 是否可以 启用 共同阶梯，1、有阶梯价；2、所有规格商品需设置阶梯且阶梯量和阶梯价需统一
      if (togetherLaddersPrice === 1) {
        if (!row.commonLaddersConfigFlag) {
          this.$message.error("所有规格商品需设置阶梯且阶梯量和阶梯价需统一，请设置后重试");
          return;
        }
      }
      let msg = "您确定要将所有规格商品设置共用阶梯价和阶梯量吗？";
      let retMsg = "启用成功";
      if (togetherLaddersPrice == 0) {
        msg = "您确定要取消所有规格商品设置共用阶梯价和阶梯量吗？";
        retMsg = "关闭成功";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        requestApi
          .post(`${process.env.VUE_APP_APITAAS}sctrading/goodsspu/mj/edit`, {
            id: row.id,
            togetherLaddersPrice: togetherLaddersPrice,
          })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success(retMsg);
              this.loadGetGoodsSpuList();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/views/seller/publishGoods/changeOuterMainColor.scss";
</style>

<style lang="scss" scoped>
@import "@/views/seller/publishGoods/changeMainColor.scss";
</style>
<style>
.manage-goods-container {
  padding: 20px;
  .table-box {
    margin-top: 30px;
  }
  .bottom-handle-box {
    padding: 10px;
    border: 1px solid #ebeef5;
  }
  .pagination-box {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .qrCode-box {
    top: -10px;
    position: relative;
    .img-box {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .nodata_line_color {
    color: #e9e9e9;
  }
}
.operated-shop {
  top: -20px;
}
.goodPriceTable {
  .el-input {
    width: 80px;
  }
}
.el-button--primary:hover,
.el-button--primary:focus {
  background: #0095f1;
  border-color: #0095f1;
  color: #ffffff;
}

.el-button--primary:active {
  background: #0095f1;
  border-color: #0095f1;
  color: #ffffff;
  outline: none;
}

.el-button--primary {
  color: #ffffff;
  background-color: #0095f1;
  border-color: #0095f1;
}

.el-button:active {
  color: #ffffff;
  outline: none;
}

.el-message-box .el-button:active {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-message-box .el-button:hover,
.el-message-box .el-button:focus {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:hover,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:active {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}
</style>
